import React, {useState, useEffect}  from 'react';
import { Button, Col, Form, FormFeedback, FormGroup, Input, Table, Label, 
    ModalBody, ModalFooter, Row, InputGroup, InputGroupAddon, InputGroupText, Alert } from 'reactstrap';
import Select from 'react-select';
import './StyleExamCreate.css';
import { cedimi,semlab, demo, pyrsa, labcen, sharp } from '../../constant/globalConstantsTypeClients';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { RadioButton } from 'primereact/radiobutton';
import { green } from '@mui/material/colors';
import { FilterMatchMode } from 'primereact/api';

export const CreateExam = (props) => {

    const {
        formValues, examId, methodExam, closeDialog, handleInputChange, handleSelectValues, handleChangePrice, validaciones, loading,
        sections, changeSelect, specimenOrigins, subSections, commercialLines, specimens, specimenProvenances, typeTransports, transports,
        cost, validationSectionArea, id_section,
        methodAction, isSimple = false, isImagenology = false,
        infoEdit = {}, examEditId, isImagenologyy, print_new_page,
         //*CONFIGURATION LABORATORY EXTERNAL
         dataLaboratory,handleChangePriceIni,
         //* curvas
         showCurveField,
         
    } = props;

    const {
        code: validationCode,
        alias: validationAlias,
        name: validationName,
        abbreviation: validationAbbreviation,
        // individual_sale: validationIndividual,
        id_section: validationSection,
        id_specimen_origin: validationSpecimenOrigen,
        list_transports: validationListTransports,
        id_specimen: validationSpecimen,
        id_specimen_provenance: validateSpecimenProvenance,
        delivery_time: validateDeliveryTime,
        cost: validateCost,



    } = validaciones;


    const {
        code
    } = formValues;
    let url_helen = localStorage.getItem('url_helen');

    const txtsection = localStorage.getItem('TextAS');
    const isCedimi = url_helen === cedimi;
    const isSemlab = url_helen === semlab;
    const isPyrsa = url_helen === pyrsa;
    const isLabcen = url_helen === labcen;
    const isSharp = url_helen === sharp;



    const showCurves = showCurveField && (isCedimi || isSemlab || isPyrsa || isLabcen || isSharp);


    const fieldCol = showCurves
    ? "col-6 col-sm-6 col-md-4 col-lg-2"
    : "col-6 col-sm-6 col-md-4 col-lg-3";

    const curveCol = "col-6 col-sm-6 col-md-4 col-lg-2";


   const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    return (
        <Form onSubmit={methodAction} >
            <Col sm="12" md="12" lg="12" className='p-l-0 p-r-0 mt-1' >
                <Row>
                    <Col sm="6" md="4" lg="3">
                    <FormGroup>
                    <Label className='f-w-600 f-12 badge badge-light-secondary'>Clave <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        value={formValues.code}
                        type="text"
                        name="code"
                        required={true}
                        autoComplete="off"
                        onChange={handleInputChange}
                        invalid={validationCode}
                    />
                    <FormFeedback>El codigo debe tener 3 o más caracteres</FormFeedback>
                </FormGroup>
                    </Col>
                    <Col sm="6" md="4" lg="3">
                    <FormGroup>
                        <Label className='f-w-600 f-12 badge badge-light-secondary'>Alias <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            className="form-control form-control-sm input-air-primary"
                            value={formValues.alias}
                            //  placeholder="Ingresa el alias"
                            type="text"
                            name="alias"
                            required={true}
                            autoComplete="off"
                            onChange={handleInputChange}
                            invalid={validationAlias}
                        />
                        <FormFeedback>El alias debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                    </Col>
                    <Col sm="6" md="4" lg="3">
                    <FormGroup>
                    <Label className='f-w-600 f-12 badge badge-light-secondary'>Abreviatura <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        value={formValues.abbreviation}
                        //placeholder="Ingresa la abreviatura"
                        type="text"
                        name="abbreviation"
                        required={true}
                        autoComplete="off"
                        onChange={handleInputChange}
                        invalid={validationAbbreviation}
                    />
                    <FormFeedback>La abreviatura debe tener 2 o más caracteres</FormFeedback>
                </FormGroup>
                    </Col>
                    <Col sm="6" md="4" lg="3">
                    <FormGroup>
                        <Label className='f-w-600 f-12 badge badge-light-secondary'>Tiempo de entrega<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            className="form-control form-control-sm input-air-primary"
                            value={formValues.delivery_time}
                            type="text"
                            name="delivery_time"
                            required={false}
                            autoComplete="off"
                            onChange={handleInputChange}
                             invalid={validateDeliveryTime}
                        />
                        <FormFeedback>El nombre debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm="6" md="6" lg="6">
                        <FormGroup>
                        <Label className='f-w-600 f-12 badge badge-light-secondary'>Nombre del exámen<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            className="form-control form-control-sm input-air-primary"
                            value={formValues.name}
                            // placeholder="Ingresa el nombre del exámen"
                            type="text"
                            name="name"
                            required={true}
                            autoComplete="off"
                            onChange={handleInputChange}
                            invalid={validationName}
                        />
                        <FormFeedback>El nombre debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                    </Col>
                    <Col sm="6" md="6" lg="6">
                        <FormGroup >
                        <Label className='f-w-600 f-12 badge badge-light-secondary'>{txtsection} <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            className="form-control form-control-sm input-air-primary"
                            value={formValues.id_section}
                            type="select"
                            name="id_section"
                            required={true}
                            onChange={changeSelect}
                            invalid={validationSection}
                        >
                            <option value="0">Selecciona una opción</option>
                            {
                                sections.length > 0 && sections.map((s, key) => {
                                    return <option key={key} value={s.id_section}>
                                        {s.name}
                                    </option>
                                })
                            }
                        </Input>
                        <FormFeedback>Debes seleccionar al menos una opción</FormFeedback>
                    </FormGroup>
                    </Col>
                    {/* <Col sm="6" md="4" lg="4">
                        <FormGroup>
                        <Label className='labelInfoAnalyte'>Subsección</Label>
                        <Input
                            className="form-control form-control-sm input-air-primary"
                            value={formValues.id_subsection}
                            type="select"
                            name="id_subsection"
                            required={true}
                            onChange={handleInputChange}
                        >
                            <option value="0">Selecciona una opción</option>
                            {
                                subSections.length > 0 && subSections.map((ss, key) => {
                                    return <option key={key} value={ss.id_subsection}>
                                        {ss.name}
                                    </option>
                                })
                            }
                        </Input>
                    </FormGroup>
                    </Col> */}
                </Row>
                <Row>
                    <Col sm="6" md="4" lg="4">
                        <FormGroup>
                            <Label className='f-w-600 f-12 badge badge-light-secondary'>Tipo de muestra <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                            <Select
                                value={formValues.id_specimen}
                                classNamePrefix="select"
                                name="id_specimen"
                                placeholder={`Selección de especimen`}
                                isClearable={false}
                                noOptionsMessage={() => "Sin opciones"}
                                options={specimens}
                                onChange={(e) => handleSelectValues(e, "id_specimen")}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}

                               
                            />
                            {validationSpecimen && (
                                <div className="invalid-feedback d-block">
                                    Debes seleccionar al menos una opción
                                </div>
                            )}
                        </FormGroup>
                    </Col>

                    <Col sm="6" md="4" lg="4">
                        <FormGroup>
                            <Label className='f-w-600 f-12 badge badge-light-secondary'>
                                Procedencia de la muestra 
                                <span className='f-16' style={{ color: "#0079C7" }}>*</span>
                            </Label>
                            <Select
                                value={formValues.id_specimen_provenance}
                                classNamePrefix="select"
                                name="id_specimen_provenance"
                                placeholder="Selecciona la procedencia"
                                isClearable={false}
                                noOptionsMessage={() => "Sin opciones"}
                                options={specimenProvenances}
                                onChange={(e) => handleSelectValues(e, "id_specimen_provenance")}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}

                            />
                            {validateSpecimenProvenance && (
                                <div className='invalid-feedback d-block'>
                                    Debes seleccionar al menos una procedencia
                                </div>
                            )}
                        </FormGroup>
                    </Col>


                    <Col sm="6" md="4" lg="4">
                        <FormGroup>
                            <Label className='f-w-600 f-12 badge badge-light-secondary'>Medio(s) de transporte <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                            <Select
                                value={formValues.list_transports}
                                isMulti
                                classNamePrefix="select"
                                name="list_transports"
                                onChange={(e) => handleSelectValues(e, "list_transports")}
                                // value={valuePeriod}
                                placeholder={`Selección de medio de transporte`}
                                isClearable={false}
                                noOptionsMessage={() => "Sin opciones"}
                                options={transports}
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                }}

                            />
                            {validationListTransports && (
                                <div className="invalid-feedback d-block">
                                    Debes seleccionar al menos un medio de trasporte
                                </div>
                            )}     
                        </FormGroup>
                    </Col>
                    
                </Row>
                <Row>
                    
                </Row>
                <br />
                
               <Row>
                    <Col className={fieldCol}>
                        <FormGroup className="d-flex flex-column align-items-center">
                            <Label>Venta individual</Label>
                            <Label className="switch mt-1">
                                <Input
                                    type="checkbox"
                                    checked={formValues.individual_sale}
                                    name="individual_sale"
                                    onChange={handleInputChange}
                                />
                                <span className="slider round"></span>
                            </Label>
                        </FormGroup>
                    </Col>

                    <Col className="col-6 col-sm-6 col-md-4 col-lg-3">
                        <FormGroup className="d-flex flex-column align-items-center">
                            <Label>¿Es referenciado?</Label>
                            <Label className="switch mt-1">
                                <Input
                                    type="checkbox"
                                    checked={formValues.is_referenced}
                                    name="is_referenced"
                                    onChange={handleInputChange}
                                />
                                <span className="slider round"></span>
                            </Label>
                        </FormGroup>
                    </Col>

                    <Col className={fieldCol}>
                        <FormGroup className="d-flex flex-column align-items-center">
                            <Label>¿Es crítico?</Label>
                            <Label className="switch mt-1">
                                <Input
                                    type="checkbox"
                                    checked={formValues.is_critic}
                                    name="is_critic"
                                    onChange={handleInputChange}
                                />
                                <span className="slider round"></span>
                            </Label>
                        </FormGroup>
                    </Col>

                    <Col className="col-5 col-sm-6 col-md-4 col-lg-3">
                        <FormGroup className="d-flex flex-column align-items-center">
                            <Label>¿Impresión en una hoja diferente?</Label>
                            <Label className="switch mt-1">
                                <Input
                                    type="checkbox"
                                    checked={formValues.print_new_page}
                                    name="print_new_page"
                                    onChange={handleInputChange}
                                />
                                <span className="slider round"></span>
                            </Label>
                        </FormGroup>
                    </Col>

                    {showCurves && (
                        <Col className={curveCol}>
                            <FormGroup className="d-flex flex-column align-items-center">
                                <Label>¿Es Curva?</Label>
                                <Label className="switch mt-1">
                                    <Input
                                        type="checkbox"
                                        checked={formValues.is_curve}
                                        name="is_curve"
                                        onChange={handleInputChange}
                                    />
                                    <span className="slider round"></span>
                                </Label>
                            </FormGroup>
                        </Col>
                    )}
                </Row>

                            </Col>
                
            
            <Row className="align-items-start">
                <Col sm="6">
                    {
                    examId > 0 ? null :
                    !formValues.is_referenced &&
                    <>
                        <Label>Precio inicial</Label>
                        <Table className="table table-bordered table-sm">
                            <tbody>
                                {
                                    commercialLines.length >= 1 && commercialLines.map((data, key) => {
                                        return (
                                            <tr key={key}>
                                                <td className='bg-secondary' >{data.short_name}</td>
                                                <td className='bg-secondary' >
                                                    <InputGroup className="">
                                                        <Input
                                                            type="number"
                                                            name="price_commercial_line"
                                                            onChange={handleChangePrice}
                                                            className="form-control"
                                                            data-id={key} step="any" placeholder="Precio inicial" />
                                                        <InputGroupAddon addonType="append"><InputGroupText>{"$"}</InputGroupText></InputGroupAddon>
                                                    </InputGroup>

                                                </td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                    </>
                    }
                </Col>
                <Col sm="6">
                    {
                    examId > 0 ? null :
                    !formValues.is_referenced &&
                    <FormGroup>
                        <Label>Costo de producción <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <InputGroup>
                        <Input
                            type="number"
                            min={0}
                            className="form-control"
                            name="cost"
                            value={cost}
                            onChange={handleInputChange}
                        />
                        <InputGroupAddon addonType="append">
                            <InputGroupText>{"$"}</InputGroupText>
                        </InputGroupAddon>
                        </InputGroup>
                        {validateCost && (
                            <div className='invalid-feedback d-block'>
                                Ingrese un costo
                            </div>
                        )}
                    </FormGroup>

                    }
                </Col>

                
            </Row>


            <Input type='hidden' value={isSimple} name="is_simple" />
            <Input type='hidden' value={isImagenology} name="isImagenology" />

            <Row>
                {
                    formValues.is_referenced &&
                    <Col sm="12" className="container-global-zoom">
                        <div className="position-relative mb-3" style={{ minHeight: "50px" }}>
                            
                            <div className="ribbon ribbon-clip ribbon-primary">
                                Asignar Precios a Laboratorios Externos
                            </div>

                            <div
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    right: 0,
                                    transform: "translateY(-50%)",
                                    width: "250px"
                                }}
                            >
                                <InputText
                                    type="search"
                                    value={filters.global.value || ""}
                                    onChange={(e) =>
                                        setFilters({
                                            global: {
                                                value: e.target.value || null,
                                                matchMode: FilterMatchMode.CONTAINS
                                            }
                                        })
                                    }
                                    placeholder="Buscar..."
                                    className="w-100"
                                    showClear
                                />
                            </div>
                        </div>
                                                


                        <div className="table-responsive ">
                            <DataTable 
                                value={dataLaboratory}
                                filters={filters}
                                filterDisplay="menu"
                                globalFilterFields={['external_laboratory']}
                                className="data-table p-datatable-striped p-datatable-sm"
                                emptyMessage={
                                    <div className="text-center">
                                        <img
                                            src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                            style={{ width: "40%" }}
                                            alt="Sin laboratorios"
                                        />
                                        <br />
                                        <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                            Sin Laboratorios.
                                        </p>
                                    </div>
                                }
                                // scrollable             
                                // scrollHeight="200px"
                                paginator
                                rows={10}
                                rowsPerPageOptions={[10, 50, 100]}
                                    responsiveLayout="scroll"


                                >


                                <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                <Column field="external_laboratory" header="Laboratorio"  headerStyle={headerStyle} style={centerStyle} />
                                <Column 
                                    header="Precio"
                                    body={(rowData) => {
                                        return (
                                            <div 
                                                style={{ 
                                                display: "flex", 
                                                flexDirection: "column", 
                                                alignItems: "center", 
                                                justifyContent: "center",
                                                gap: "5px",
                                                width: "100%" 
                                                }}
                                            >
                                                <div className="price-input-wrapper">
                                                    <i className="fa fa-usd price-icon"></i>
                                                    <InputNumber
                                                        // className="input-air-primary"
                                                        min={0}
                                                        step="any"
                                                        value={rowData.price}
                                                        name='amount'
                                                        allowEmpty
                                                        locale="en-US"
                                                        maxFractionDigits={2} 
                                                        onChange={(e) =>
                                                            handleChangePriceIni(
                                                                { target: { value: e.value, name: 'amount' } },
                                                                rowData.id_external_laboratory
                                                            )
                                                        }
                                                    

                                                    />
                                                </div>
                                            </div>
                                        );
                                    }}
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />
                                <Column 
                                    header="Costo"
                                    body={(rowData) => {
                                    
                                        return (
                                            <div 
                                                style={{ 
                                                display: "flex", 
                                                flexDirection: "column", 
                                                alignItems: "center", 
                                                justifyContent: "center",
                                                gap: "5px",
                                                width: "100%" 
                                                }}
                                            >
                                            <div className="price-input-wrapper">
                                                    <i className="fa fa-usd price-icon"></i>

                                                    <InputNumber
                                                        className="input-air-primary price-input"
                                                        value={rowData.cost}
                                                        min={0}
                                                        step="any"
                                                        name="cost"
                                                        locale="en-US"
                                                        maxFractionDigits={2} porquwe
                                                        allowEmpty
                                                        style={{ zIndex: 1 }}
                                                        onChange={(e) =>
                                                            handleChangePriceIni(
                                                                { target: { value: e.value, name: 'cost' } },
                                                                rowData.id_external_laboratory
                                                            )
                                                        }
                                                    
                                                    />
                                                </div>

                                            
                                            </div>
                                        );
                                    }}
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />         
                                
                                <Column 
                                    header="Default"
                                    body={(rowData) => {
                                    
                                        return (
                                            <div 
                                                style={{ 
                                                display: "flex", 
                                                flexDirection: "column", 
                                                alignItems: "center", 
                                                justifyContent: "center",
                                                gap: "5px",
                                                width: "100%" 
                                                }}
                                            >
                                            <RadioButton 
                                                inputId="defaultLabKey"
                                                name="default_lab"
                                                value={rowData.default_lab}
                                                onChange={(e) => handleChangePriceIni(e,rowData.id_external_laboratory )}
                                                checked={rowData.default_lab}
                                                style={{ zIndex: 1 }}
                                                />


                                            </div>
                                        );
                                    }}
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />         
                                
                            </DataTable>
                        </div>  

                    </Col>
                }
            </Row>
      
            {/* <ModalFooter> */}
            <div className="d-flex justify-content-end gap-2">

                {
                    isSimple || isImagenology ? (
                        <Button
                        color={loading ? "warning" : "primary"} 
                        type="submit"
                        disabled={loading}
                        className={`${(examId > 0 && examEditId === undefined) ? "d-none" : ""} ${loading ? "disabled progress-bar-animated progress-bar-striped" : ""}`}
                        >
                        {loading && (
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        )}
                        {loading ? " Guardando..." : (examEditId === undefined ? "Guardar" : "Actualizar")}
                        </Button>
                    ) : (
                        <Button
                        size='sm'
                        color={loading ? "warning" : "primary"}
                        type="submit"
                        disabled={loading}
                        className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                        >
                        {loading && (
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        )}
                        {loading ? " Guardando..." : "Guardar"}
                        </Button>
                    )
                }
                <div className='mr-1'>

                </div>

                {
                    !isSimple &&
                    <Button size="sm" className="btn-air-light" color="danger" type="button" onClick={closeDialog}>Cancelar</Button>
                }
                </div>

         
        </Form >
    )
}
